import ReactDOM from 'react-dom'
import App from './App'
import 'react-toastify/dist/ReactToastify.css'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { CssBaseline } from '@material-ui/core'
import { PostHogProvider } from 'posthog-js/react'
import PostHogRouteTracker from './analytics/PostHogRouteTracker'

ReactDOM.render(
  <PostHogProvider
    apiKey={process.env.REACT_APP_POSTHOG_KEY}
    options={{
      api_host: process.env.REACT_APP_POSTHOG_HOST,
      defaults: '2025-05-24',
      capture_exceptions: true,
      autocapture: true,
      capture_pageview: false,
      debug: process.env.NODE_ENV === 'development',
    }}
  >
    <BrowserRouter>
      <CssBaseline />
      <ToastContainer />
      <PostHogRouteTracker />
      <App />
    </BrowserRouter>
  </PostHogProvider>,
  document.getElementById('root'),
)
